import scrollTo from './scrollTo';

class Scroll {

    /**
     * Make a new Scroll trigger.
     * @constructs
     * @param {HTMLElement} element
     * @param {{}} options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._initialize();
    }

    /**
     * Initialize
     * @private
     */
    _initialize() {
        if (this._element) {
            const targetElement = document.querySelector(this._options.target);
            this._element.addEventListener('click', event =>
                scrollTo(event, targetElement.offsetTop)
            );
        }
    }
}

export default Scroll;
